import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
} from 'reactstrap';
import Switch from 'rc-switch';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import ReactQuill from 'react-quill';

const fieldsListData = [
  {
    id: 'Name',
    name: 'Name',
  },
  {
    id: 'Email',
    name: 'Email',
  },
  {
    id: 'PhoneNumber',
    name: 'Phone Number',
  },
  {
    id: 'Username',
    name: 'Username',
  },
  {
    id: 'Password',
    name: 'Password',
  },
];
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link'],
    ['clean'],
  ],
};

const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
];
export function VisitorFormSettings({
  visible,
  toggle,
  formLabel,
  submit,
  visitorData,
}) {
  const [updateVisitorData, setUpdateVisitorData] = useState({});
  const [fieldList, setFieldList] = useState([]);
  useEffect(() => {
    if (visitorData !== null && visitorData !== undefined) {
      setUpdateVisitorData({
        ...updateVisitorData,
        title: visitorData.title,
        buttonText: visitorData.buttonText,
        fields: visitorData.fields,
        enabled: visitorData.enabled,
        subTitle: visitorData.subTitle,
      });

      let dataValues = fieldsListData.map((elem) => {
        elem.on_off = false;
        elem.required = false;
        elem.isEnabled = true;
        if (visitorData.fields !== null) {
          visitorData.fields.forEach((r) => {
            if (r.field === elem.id) {
              if (r.mandatory !== null && r.mandatory) {
                elem.on_off = true;
              } else {
                elem.on_off = false;
              }
              elem.required = true;
            }
          });
        }
        return elem;
      });
      setFieldList(dataValues);
    } else {
      setUpdateVisitorData({
        ...updateVisitorData,
        title: 'Welcome to Hotel',
        buttonText: 'Start Conversation',
        subTitle:
          'Please leave your contact details to make sure we can get back in case you still have unanswered questions',
        fields: [],
        enabled: false,
      });

      setFieldList(
        fieldsListData.map((elem) => {
          elem.on_off = false;
          elem.isEnabled = true;
          elem.required = false;
          return elem;
        })
      );
    }
  }, []);

  const handleChange = (e) => {
    setUpdateVisitorData({
      ...updateVisitorData,
      [e.target.name]: e.target.value,
    });
  };
  const handleCheckChange = (e) => {
    if (e) {
      setUpdateVisitorData({
        ...updateVisitorData,
        enabled: false,
      });
    } else {
      setUpdateVisitorData({
        ...updateVisitorData,
        enabled: true,
      });
    }
  };
  const handleFieldChange = (e) => {
    const values = fieldList.map((elem) => {
      if (elem.name === e.name) {
        if (elem.on_off) {
          elem.on_off = false;
        } else if (!elem.on_off) {
          elem.on_off = true;
        }
      }
      return {
        ...elem,
      };
    });
    setFieldList(values);
    let fieldArr = [];
    values.map((m) => {
      if (m.required === true && m.isEnabled) {
        if (m.on_off == true) {
          fieldArr.push({
            field: m.id,
            mandatory: true,
          });
        } else {
          fieldArr.push({
            field: m.id,
            mandatory: false,
          });
        }
      }
    });

    setUpdateVisitorData({
      ...updateVisitorData,
      fields: fieldArr,
    });
  };
  const handleElementCheckChange = (id, enabled, checked) => {
    const values = fieldList.map((f) => {
      if (f.id === id) {
        if (f.required === true) {
          f.required = false;
        } else {
          f.required = true;
        }
      }
      return { ...f };
    });
    setFieldList(values);
    let fieldArr = [];
    values.map((m) => {
      if (m.required === true && m.isEnabled) {
        if (m.on_off == true) {
          fieldArr.push({
            field: m.id,
            mandatory: true,
          });
        } else {
          fieldArr.push({
            field: m.id,
            mandatory: false,
          });
        }
      }
    });

    setUpdateVisitorData({
      ...updateVisitorData,
      fields: fieldArr,
    });
  };
  const handleSubTitleChange = (source, data) => {
    setUpdateVisitorData({
      ...updateVisitorData,
      subTitle: data,
    });
  };
  const handleSubmit = () => {
    submit(updateVisitorData);
  };
  return (
    <Fragment>
      {updateVisitorData !== null && (
        <Modal isOpen={visible} toggle={toggle} size="lg">
          <ModalHeader toggle={toggle}>
            <b>{formLabel}</b>
            <br />
            <span style={{ fontSize: '12px', marginTop: '1px' }}>
              Customise the messaging and the fields to appear on the Pre Chat
              form. Pre Chat form will help you capture more contact details and
              marketing consents. On the other hand Pre Chat form usually reduce
              conversations volume by around 20% on average.
            </span>
          </ModalHeader>
          {
            <ModalBody>
              <Row className="mb-4">
                <Colxx xxs="12">
                  {/* <pre>{JSON.stringify(updateEyeCatcherNudgesData, null, 2)}</pre> */}
                  <Row>
                    <Colxx sm={12}>
                      <Label>Enable</Label>
                      <CustomInput
                        type="checkbox"
                        id="1"
                        checked={updateVisitorData.enabled}
                        name="enabled"
                        onChange={() => {
                          handleCheckChange(updateVisitorData.enabled);
                        }}
                      />
                    </Colxx>
                    <Colxx sm={12} className="mb-6 mt-2">
                      <Label>Title</Label>
                      <Input
                        type="text"
                        value={updateVisitorData.title}
                        onChange={handleChange}
                        name="title"
                      />
                    </Colxx>
                    <Colxx sm={12} className="mb-6 mt-2">
                      <Label>Sub Title</Label>
                      <ReactQuill
                        theme="snow"
                        value={updateVisitorData.subTitle}
                        onChange={(content, delta, source) =>
                          handleSubTitleChange(source, content)
                        }
                        modules={quillModules}
                        formats={quillFormats}
                        name="subTitle"
                      />
                    </Colxx>
                    <Colxx sm={3} className="mb-6  mt-2">
                      <Label>Button Text</Label>
                      <Input
                        type="text"
                        value={updateVisitorData.buttonText}
                        onChange={handleChange}
                        name="buttonText"
                      />
                    </Colxx>
                    <Colxx sm={9} className="mb-6  mt-2">
                      {/* <Label>Checkbox Text</Label>
                      <ReactQuill
                        theme="snow"
                        value={updateVisitorData.checkboxText}
                        onChange={(content, delta, source) =>
                          handleCheckboxTextChange(source, content)
                        }
                        modules={quillModules}
                        formats={quillFormats}
                        name="checkboxText"
                      />
                      {/* <Input
                        type="text"
                        value={updateVisitorData.checkboxText}
                        onChange={handleChange}
                        name="checkboxText"
                      />*/}
                    </Colxx>
                    <Colxx sm={7} className="mb-6 mt-2">
                      <div className="d-flex">
                        <Colxx sm={5} className=" d-flex mb-1">
                          <Label>Fields</Label>
                        </Colxx>
                        <Colxx>
                          <Label className="">Mandatory Field</Label>
                        </Colxx>
                      </div>

                      {fieldList.map((elem, index) => (
                        <Fragment key={index}>
                          <div className="d-flex">
                            <Colxx sm={5} className=" d-flex mb-1">
                              <CustomInput
                                key={index}
                                type="checkbox"
                                value={elem?.name}
                                id={elem?.name}
                                onChange={() => {
                                  handleElementCheckChange(
                                    elem.id,
                                    elem.isEnabled,
                                    elem.required
                                  );
                                }}
                                checked={elem.required}
                                disabled={!elem.isEnabled}
                              ></CustomInput>
                              <span className="mt-1">{elem?.name}</span>
                            </Colxx>
                            <Colxx sm={2} className="mb-1 text-center">
                              {elem.required ? (
                                <Switch
                                  className="agentswitch custom-switch-primary custom-switch-small"
                                  onChange={() => {
                                    handleFieldChange(elem);
                                  }}
                                  checked={elem.on_off}
                                />
                              ) : null}
                            </Colxx>
                          </div>
                        </Fragment>
                      ))}
                    </Colxx>
                  </Row>
                </Colxx>
              </Row>
            </ModalBody>
          }
          <ModalFooter>
            <Button color="primary" onClick={handleSubmit}>
              Update
            </Button>
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </Fragment>
  );
}
